export function Fabble({ className }: { className?: string }) {
	return (
		<svg className={className} viewBox="0 0 239.4141 239.4141" role="img">
			<title>Fabble</title>
			<circle
				cx="119.7071"
				cy="119.7071"
				r="115.5791"
				fill="none"
				stroke="currentColor"
				strokeWidth="8.2558"
				strokeMiterlimit="10"
			/>
			<path
				fill="currentColor"
				d="M132.85,142.0883a16.2019,16.2019,0,0,1,16.6135-4.7233,16.017,16.017,0,0,1,11.363,11.6887,5.892,5.892,0,0,0,9.9965,3.0514c8.7253-8.9874,17.341-18.0814,26.1861-27.3273-.486-.4161-.8959-.7352-1.2694-1.0918-8.5128-8.1272-17.0458-16.2334-25.4964-24.4241a7.75,7.75,0,0,1-2.1191-3.566c-.7812-3.3524,1.2011-5.9581,4.988-7.0279a16.4032,16.4032,0,0,0-7.5536-31.8968,16.17,16.17,0,0,0-12.9207,12.3835,9.1533,9.1533,0,0,1-1.8675,3.7226,5.7975,5.7975,0,0,1-8.1988.0368q-.1571-.1556-.3019-.3228-12.8787-12.2822-25.7225-24.6a5.2813,5.2813,0,0,1-.7507-1.4135c-9.13,9.5377-17.7851,18.5284-26.3515,27.6051a6.4641,6.4641,0,0,0-1.5441,3.3965,5.8013,5.8013,0,0,0,4.9447,6.5466q.15.0209.3014.034a16.3612,16.3612,0,0,1,12.6974,17.3671,16.8545,16.8545,0,0,1-3.3509,8.5951c-.3595.4684-.6867.8393-.9253,1.0974l-35.5779,35.92a50.4647,50.4647,0,0,1,.0809-9.8789A74.6805,74.6805,0,0,1,84.9307,95.9286a1.25,1.25,0,0,0,.1742-.9584,43.0387,43.0387,0,0,0-30.2763,14.79,47.5007,47.5007,0,0,0-10.4807,34.3405,58.135,58.135,0,0,0,21.025,37.92C77.8314,192.08,93.6067,194.55,109.1044,194.58a124.1823,124.1823,0,0,0,19.9831-2.3286,106.2363,106.2363,0,0,1-33.1232-8.0234Z"
				transform="translate(-0.8721 -0.8721)"
			/>
		</svg>
	);
}
